export const aventriTempDocTypes = {
  session: 'aventriSession',
  speaker: 'aventriSpeaker',
}
